import { FC } from 'react';

import { css } from '@emotion/react';
import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import { useTranslation } from 'next-i18next';

import { Language } from '~/constants/languages';
import { useIsSnoozedForNewLanguageQuery } from '~/extension/schema';
import { getAvatarNumber } from '~/helpers/dashboard';

enum ToucanAvatars {
  Beanie,
  Cap,
  Crown,
  Party,
  Scarf,
  Space,
  Sunglasses,
  Sunhat,
}

interface AvatarProps {
  className?: string;
  userEmail?: string;
  language?: Language;
}

const Avatar: FC<AvatarProps> = ({ className, userEmail, language }) => {
  let avatarFileName = 'anonymous';
  const theme = useTheme();
  const { t } = useTranslation('onboarding');

  const { data } = useIsSnoozedForNewLanguageQuery();
  const { isSnoozedForNewLanguage } = data?.settings ?? false;

  if (userEmail) {
    const avatarIndex = getAvatarNumber(userEmail, 7);
    avatarFileName = (ToucanAvatars[avatarIndex] ?? '').toLowerCase();
  }

  return (
    <Box
      display="flex"
      justifyContent="flex-end"
      alignItems="flex-end"
      className={className}
      mb={0.5}
      css={css`
        background-image: url(/images/dashboard/avatar/${avatarFileName}.svg);
        background-position: center center;
        background-repeat: no-repeat;
        width: 64px;
        height: 64px;
      `}
    >
      {language && !isSnoozedForNewLanguage && (
        <img
          src={`/images/flags/round/${language}.svg`}
          width="20"
          height="20"
          alt={t('onboardingLanguageFlag')}
          css={css`
            margin-bottom: ${theme.spacing(0.4)};
          `}
        />
      )}
    </Box>
  );
};

export default Avatar;
